import React from 'react';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// components
import MaintenancePage from "./pages/MaintenancePage";

function App() {
  // Socket แจ้งเตือน (ใบเสนอราคา + timesheet) ย้ายไปที่ services/notificationSocket.js
  // และ toast แสดงจาก NotificationBell ใน Header เพื่อให้คลิกแล้วเปิดหน้าได้

  const isMaintenance = process.env.REACT_APP_MAINTENANCE === "true";

  if (isMaintenance) {
    return <MaintenancePage />;
  }


  return (
    <>
      <ToastContainer />
      <AppRoutes />
    </>
  );
}

export default App;
